import { get, post, upload } from '@/request/request';

export default {
  chunkUpload(data) {
    return upload('/admin/storage/chunk/upload', data);
  },
  chunkMerge(data) {
    return post('/admin/storage/chunk/merge', data);
  },
  fileOutput(filename, token, is_dow = false) {
    const params = {
      filename: filename,
      token: token,
      is_dow: is_dow
    };
    return get('/admin/storage/file/output', params);
  }
};
